<template>
  <div class="logo-animation align-center d-none d-md-flex">
    <svg viewBox="0 0 500 500" id="svg-logo">
      <filter id="displacementFilter">
        <feTurbulence
          type="turbulence"
          baseFrequency="0.05"
          numOctaves="3"
          result="turbulence"
        />
        <feDisplacementMap
          in2="turbulence"
          in="SourceGraphic"
          scale="50"
          xChannelSelector="R"
          yChannelSelector="G"
        />
      </filter>
      <defs>
        <clipPath id="clip-svg-logo">
          <rect width="500" height="500" />
        </clipPath>
      </defs>
      <g
        id="logo"
        clip-path="url(#clip-svg-logo)"
        style="filter: url(#displacementFilter);transform-origin:center;"
      >
        <g id="favicon.ico.light" transform="translate(8556.624 313.624)">
          <g
            id="center_focus_weak-24px"
            transform="translate(-8405.001 -161.984)"
          >
            <path
              id="Path_1642"
              data-name="Path 1642"
              d="M0,0H196.123V196.123H0Z"
              fill="none"
            />
            <path
              id="Path_1643"
              data-name="Path 1643"
              d="M127.818,84.667a43.151,43.151,0,1,0,43.151,43.151A43.139,43.139,0,0,0,127.818,84.667Zm0,64.727a21.575,21.575,0,1,1,21.575-21.575A21.638,21.638,0,0,1,127.818,149.393Z"
              transform="translate(-29.467 -29.465)"
              fill="#fff"
            />
          </g>
          <g id="Galben" transform="translate(-8405.001 -161.984)">
            <path
              id="Path_1642-2"
              data-name="Path 1642"
              d="M0,0H196.123V196.123H0Z"
              fill="none"
            />
            <path
              id="Path_1643-2"
              data-name="Path 1643"
              d="M24.576,24.576H67.727V3H24.576A21.639,21.639,0,0,0,3,24.576V67.727H24.576Z"
              transform="translate(-1.019 -1.019)"
              fill="#ffba30"
            />
          </g>
          <g id="Verde" transform="translate(-8403.358 32.499) rotate(-90)">
            <path
              id="Path_1642-3"
              data-name="Path 1642"
              d="M0,0H83.789V194.73H0Z"
              transform="translate(112.333 1.392)"
              fill="none"
            />
            <path
              id="Path_1643-3"
              data-name="Path 1643"
              d="M21.576,21.576H64.727V0H21.576A21.639,21.639,0,0,0,0,21.576V64.727H21.576Z"
              transform="translate(-0.33 -0.33)"
              fill="#00a15f"
            />
          </g>
          <g id="Albastru" transform="translate(-8210.501 32.499) rotate(180)">
            <path
              id="Path_1642-4"
              data-name="Path 1642"
              d="M0,0H83.789V194.73H0Z"
              transform="translate(112.333 1.392)"
              fill="none"
            />
            <path
              id="Path_1643-4"
              data-name="Path 1643"
              d="M21.576,21.576H64.727V0H21.576A21.639,21.639,0,0,0,0,21.576V64.727H21.576Z"
              transform="translate(-0.33 -0.33)"
              fill="#307eff"
            />
          </g>
          <g id="Rosu" transform="translate(-8210.501 -159.356) rotate(90)">
            <path
              id="Path_1642-5"
              data-name="Path 1642"
              d="M0,0H83.789V194.752H0Z"
              transform="translate(112.333 1.371)"
              fill="none"
            />
            <path
              id="Path_1643-5"
              data-name="Path 1643"
              d="M21.576,21.576H64.727V0H21.576A21.639,21.639,0,0,0,0,21.576V64.727H21.576Z"
              transform="translate(-0.33 -0.33)"
              fill="#ff3030"
            />
          </g>
        </g>
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'Animejs',
  mounted() {
    const targets = this.$el
    this.$anime
      .timeline({
        delay: 1000,
        easing: 'easeInOutQuart',
        duration: 5000
      })
      .add({
        targets: '#svg-logo',
        keyframes: [
          { scale: 0.3, rotate: '0deg' },
          { scale: 0.5, rotate: '360deg' }
        ],
        duration: 4000
      })
      .add(
        {
          targets: ['#logo', 'feTurbulence', 'feDisplacementMap'],

          baseFrequency: 0,
          // numOctaves: 10,
          rotate: '360deg',
          scale: 1,
          fill: '#fff',
          fillOpacity: '1'
        },
        '-=5000'
      )
      .add({
        targets: '#svg-logo',
        scale: 0.1,
        keyframes: [{ translateY: -1100 }],
        delay: 1000,
        duration: 1000
      })
  }
}
</script>
<style>
@media (min-width: 576px) {
  .d-md-flex {
    display: flex;
  }
}
.logo-animation {
  display: flex;
  flex-flow: row nowrap;
  place-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  z-index: 1040;
}
#svg-logo {
  position: absolute;
  top: 3vh;
  flex: 0 1 auto;
  align-self: center;
  min-width: 0px;
  min-height: auto;
  width: 500px;
  overflow: visible;
  z-index: 1040;
}
</style>
